import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import RmvendorEditForm from './RmvendorEditForm';
import RmvendorList from './RmvendorList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import RmvendorListView from './RmvendorListView'


export default function RmvendorDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.rmvendorDashboard);
  const [ rmvendorId, setRmvendorId] = React.useState('');
  const [reloadRmvendorList, setReloadRmvendorList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <RmvendorEditForm 
            setReloadRmvendorList={setReloadRmvendorList}
            rmvendorId={rmvendorId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <RmvendorListView 
                      setRmvendorId = {setRmvendorId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
